<template>
    <div class="land-box">
        <div class="land-top">
            <MessageHeader msg="土地数据总览"></MessageHeader>
            <LandItem
                :keys="dataStrArr"
                :land-chart-list="landChartList"
                :land-list="landList"
            />
        </div>
        <div class="child-list">
            <MessageHeader msg="子市场数据一览"></MessageHeader>
            <div class="child-table rs-el-table">
                <el-table :data="childData" header-row-class-name="tableHeader" table-layout="auto">
                    <el-table-column prop="areaName" label="区县" width="180"/>
                    <el-table-column prop="transferArea" label="出让面积（亩）"/>
                    <el-table-column prop="numLandParcelsTransferred" label="出让宗地数"/>
                    <el-table-column prop="averageTransactionPrice" label="成交均价（万元/亩）"/>
                </el-table>
            </div>

        </div>

        <!--    土地供应趋势    -->
        <div class="trend-box">
            <MessageHeader msg="土地供应趋势"></MessageHeader>
            <div class="trend-chart">
                <Lines
                    :data="trendData"
                ></Lines>
            </div>

        </div>
        <div class="dynamic-box">
            <MessageHeader msg="土地交易动态"></MessageHeader>
            <div class="dynamic-table">
                <ScrollTable
                    :tableHead="tableHead"
                    :table-data="dynamicsData"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref, watch} from "vue";
import MessageHeader from '@/components/MessageHeader'
import ScrollTable from '@/components/scrollTable'
import LandItem from '@/components/landItem'
import Lines from '@/components/charts/chartLine'

import request from "@/service/request";
import {
    dynamicsTransactionTable,
    getLandChildData,
    getLandData,
    getLandTrends
} from "@/service/api";

const props = defineProps({
    code:{
        type:String,
        default:''
    }
})
/** 土地总览 **/
const dataStrArr = reactive({
    transferArea: {str: '出让面积', unit: '亩'},
    numLandParcelsTransferred: {str: '出让宗地数', decimal :0},
    averageTransactionPrice: {str: '成交均价', unit: '万元/亩'},

})
const landList = ref({})
const landChartList = ref([])


const getLand = async () => {
    let {data} = await request({
        url: getLandData,
        method: 'get',
        data: {cityCode: props.code}
    })
    let obj = {}
    for (let key in dataStrArr) {
        obj[key] = data[key]
    }
    landList.value = obj
    landChartList.value = data.landTypeProportion || []
    console.log(landChartList.value,"ggggggggggg")
}
/** 子市场数据 **/
let childData = ref([])
const getChildData = async () => {
    let {data} = await request({
        url: getLandChildData,
        method: 'get',
        data: {cityCode: props.code}
    })
    data.forEach(item => {
        item.transferArea = item.transferArea ? item.transferArea.toFixed(2) : 0;
        item.averageTransactionPrice = item.averageTransactionPrice ? item.averageTransactionPrice.toFixed(2) : "-"
    })
    childData.value = data
}

/**动态数据**/
let dynamicsData = ref([])
const tableHead = ref([
    {props: 'areaName', label: '区县',width:100 },
    {props: 'address', label: '宗地位置'},
    {props: 'landUseArea', label: '用地面积（亩）'},
    {props: 'landCharacteristics', label: '土地性质'},
    {props: 'transactionPrice', label: '成交价格（万元）',fixed:2},
    {props: 'winningBidder', label: '竞得人'},
])
/**子数据动态**/
const getDynamicsData = async () => {
    let {data} = await request({
        url: dynamicsTransactionTable,
        method: 'get',
        data: {cityCode: props.code}
    })
    dynamicsData.value = data
}
/**趋势**/
const trendData = ref([])
const getTrend =  async () => {
    let {data} = await request({
        url: getLandTrends,
        method: 'get',
        data: {cityCode: props.code}
    })
    trendData.value = data
}
watch(()=>props.code,()=>{
    getLand()
    getChildData()
    getDynamicsData()
    getTrend()
})
onMounted(() => {
    getLand()
    getChildData()
    getDynamicsData()
    getTrend()
})

</script>

<style lang="less" >
.land-box {
    width: 100%;

    .land-top {
        margin-top: 20px;
    }

    .child-list {
        margin-top: 20px;

        .child-table {
            margin-top: 20px;
            height: 540px;
            background: #FFFFFF;
            box-sizing: border-box;
            padding: 30px;

            .el-table {
                width: 100%;
                height: 100%;

                .header-lable {
                    display: flex;
                    align-items: center;
                    //flex-shrink: 0;
                    justify-content: space-between;

                    .iconfont {
                        margin-left: 5px;
                        color: #666666;

                    }
                }
            }

            .tableHeader {
                font-size: 14px;
                font-weight: 400;
                color: #333333;

                .cell {
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
    .trend-box {
        margin-top: 20px;
        .trend-chart{
            width: 100%;
            margin-top: 20px;
            height: 284px;
            background: #FFFFFF;
            padding: 30px;
            box-sizing: border-box;
        }

    }
    .dynamic-box {
        margin-top: 20px;
        .dynamic-table {
            box-sizing: border-box;
            padding: 30px;
            margin-top: 20px;
            height: 328px;
            background: #FFFFFF;
            padding-top: 20px;

        }
    }

}
</style>
